import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const oauthService = inject(OAuthService);

  if (oauthService.hasValidAccessToken()) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${oauthService.getAccessToken()}`,
      },
    });
  }

  return next(req);
};
